import { useMemo } from "react";

export const useAmountPercent = (amount: number, balance: number) => {
  return useMemo(() => {
    const percent = (amount * 100) / balance;
    return Number.isNaN(percent) || !Number.isFinite(percent) ? 0 : percent;
  }, [amount, balance]);
};
